import { GoogleLoginResponse } from 'react-google-login'
import {
  GetClientResponse,
  GetClientsResponse,
  GetCountersResponse,
} from '../@types/api'
import {
  ActivateClientPayload,
  DeleteClientPayload,
  PauseClientPayload,
  UpdateClientPayload,
} from '../api/api'

export const SET_TOKEN = 'SET_TOKEN'
export const SET_GOOGLE_TOKEN = 'SET_GOOGLE_TOKEN'
export const GET_COUNTERS = 'GET_COUNTERS'
export const GET_CLIENTS = 'GET_CLIENTS'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENT = 'SET_CLIENT'
export const UPDATE_CLIENT = 'UPDATE_CLIENT'
export const DELETE_CLIENT = 'DELETE_CLIENT'
export const PAUSE_CLIENT = 'PAUSE_CLIENT'
export const ACTIVATE_CLIENT = 'ACTIVATE_CLIENT'
export const SET_COUNTERS = 'SET_COUNTERS'
export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_APP_ERROR = 'SET_APP_ERROR'
export const CLEAR_APP_ERROR = 'CLEAR_APP_ERROR'
export const LOG_OUT = 'LOG_OUT'

export enum AppError {
  IncorrectToken = 'IncorrectToken',
  Forbidden = 'Forbidden',
  InternalServerError = 'InternalServerError',
  ServiceUnavailable = 'ServiceUnavailable',
  NullResponse = 'NullResponse',
  Other = 'Other',
}

export interface State {
  app: AppState
  routing?: any
}
export interface AppState {
  clients: GetClientsResponse
  googleAccount: GoogleLoginResponse | null
  googleToken: string | null
  isGoogleLoggedIn: boolean
  token: string
  isLoading: boolean
  isClientsLoading: boolean
  appError?: AppError
}

export interface SetAppErrorAction {
  type: typeof SET_APP_ERROR
  payload: AppError
}

export interface SetCounters {
  type: typeof SET_COUNTERS
  payload: CountersPayload
}

export interface SetClients {
  type: typeof SET_CLIENTS
  payload: ClientsPayload
}
export interface SetClient {
  type: typeof SET_CLIENT
  payload: ClientPayload
}

export interface UpdateClient {
  type: typeof UPDATE_CLIENT
  payload: UpdateClientPayload
}

export interface DeleteClientAction {
  type: typeof DELETE_CLIENT
  payload: DeleteClientPayload
}

export interface PauseClientAction {
  type: typeof PAUSE_CLIENT
  payload: PauseClientPayload
}

export interface ActivateClientAction {
  type: typeof ACTIVATE_CLIENT
  payload: ActivateClientPayload
}

export interface SetIsGoogleLoggedIn {
  type: typeof SET_GOOGLE_TOKEN
  payload: string
}

export interface SetToken {
  type: typeof SET_TOKEN
  payload: string
}

export interface GetCounters {
  type: typeof GET_COUNTERS
}

export interface GetClients {
  type: typeof GET_CLIENTS
}

export interface ClearAppErrorAction {
  type: typeof CLEAR_APP_ERROR
}

export interface LogoutAction {
  type: typeof LOG_OUT
}

export interface ClientsPayload extends GetClientsResponse {}
export interface ClientPayload extends GetClientResponse {}
export interface Counters extends GetCountersResponse {}
export interface CountersPayload extends GetCountersResponse {}

export type ActionTypes =
  | SetAppErrorAction
  | ClearAppErrorAction
  | GetCounters
  | SetCounters
  | SetToken
  | SetIsGoogleLoggedIn
  | GetClients
  | SetClients
  | SetClient
  | UpdateClient
  | LogoutAction
  | DeleteClientAction
  | PauseClientAction
  | ActivateClientAction
